<template>
  <div class="sidebar-wrapper">
    <div class="logo-container">
      <div class="logo-mark">W</div>
      <div class="logo-text" v-if="$store.getters.sidebarOpened">
        <h1 class="logo-title">汪汪职道</h1>
        <span class="logo-subtitle">Admin Console</span>
      </div>
    </div>
    <el-scrollbar class="menu-scrollbar">
      <sidebar-menu></sidebar-menu>
    </el-scrollbar>
  </div>
</template>

<script setup>
import SidebarMenu from './SidebarMenu'
</script>

<style lang="scss" scoped>
.sidebar-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.logo-container {
  min-height: 72px;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  border-bottom: 1px solid rgba(148, 163, 184, 0.14);
  transition: all 0.28s;

  .logo-mark {
    width: 36px;
    height: 36px;
    flex-shrink: 0;
    border-radius: 10px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    background: #2563eb;
    font-size: 18px;
    font-weight: 800;
    letter-spacing: 0;
  }

  .logo-text {
    min-width: 0;
  }

  .logo-title {
    margin: 0;
    color: #fff;
    font-weight: 700;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0;
  }

  .logo-subtitle {
    display: block;
    margin-top: 2px;
    color: #94a3b8;
    font-size: 11px;
    line-height: 14px;
  }
}

.menu-scrollbar {
  flex: 1;
  overflow: hidden;

  :deep(.el-scrollbar__wrap) {
    overflow-x: hidden;
  }
}
</style>
